var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-how-it-works-info-schemes"},_vm._l((_vm.amount),function(i){return _c('img',{key:i,staticClass:"plugin-how-it-works-info-schemes__image",class:{ _active: _vm.activeItemIndex + 1 === i },attrs:{"src":require(`/static/images/plugin-how-it-works-info_${i}.svg`)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }